import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const NotFound = () => {
  return (
    <div className="bg-[#050505] text-white min-h-[70vh] flex items-center justify-center px-6" data-testid="not-found-page">
      <SEO
        title="Page Not Found"
        description="The page you were looking for could not be found on Bronto Platforms."
        path="/404"
        noindex
      />
      <div className="max-w-xl text-center">
        <p className="text-sm tracking-[0.3em] text-white/40 uppercase mb-6">Error 404</p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-semibold mb-6 leading-tight">
          This page doesn&apos;t exist.
        </h1>
        <p className="text-base text-white/60 mb-10">
          The link may be broken or the page may have been moved. Let&apos;s get you back somewhere useful.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 rounded-full bg-white text-black px-6 py-3 text-sm font-medium hover:bg-white/90 transition-colors"
          data-testid="back-to-home"
        >
          Return to homepage
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
